import { useTranslation } from "react-i18next";

export const OrSeparator = () => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-row">
      <hr className="w-full border-border-tertiary" />
      <span className="px-2 pt-px font-semibold text-foreground-primary">
        {t("portal:common.or")}
      </span>
      <hr className="w-full border-border-tertiary" />
    </div>
  );
};
